export const category  = (state, action) => {
	switch(action.type) {
		case 'ADD_CATEGORY':
			return {
				id : action.id,
				name : action.name,
				slug : action.name.toLowerCase().match(/[a-zA-Z0-9\-]/g).join('-')
			}
		default:
			return state;
	}
}
 
export const categories = (state = [], action) => {
	switch(action.type) {
		case 'ADD_CATEGORY':
			return (function (state, action) {
				var c = state.slice();
				c.push(category(undefined, action));
				return c;
			})(state,action);
		case 'REFRESH_CATEGORIES':
			if(typeof action.value !== 'undefined')
				return action.value;
			else
				return state;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/common/reducers/categories.js